var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "study-page" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "video-container",
          class: { "video-loading": !_vm.videoReady }
        },
        [
          !_vm.videoReady && _vm.playerOptions.sources[0].src
            ? _c("div", { staticClass: "video-skeleton" }, [
                _c("div", { staticClass: "skeleton-shimmer" }),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "skeleton-text" }, [
                  _vm._v("视频加载中...")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.playerOptions.sources[0].src && !_vm.pdfuri && !_vm.videoReady
            ? _c("div", { staticClass: "video-placeholder" }, [
                _c("div", { staticClass: "placeholder-icon" }, [
                  _c("svg", { attrs: { viewBox: "0 0 24 24", fill: "none" } }, [
                    _c("rect", {
                      attrs: {
                        x: "2",
                        y: "4",
                        width: "20",
                        height: "16",
                        rx: "2",
                        stroke: "currentColor",
                        "stroke-width": "2"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: { d: "M10 9l5 3-5 3V9z", fill: "currentColor" }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "placeholder-text" }, [
                  _vm._v("课程内容加载中")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.playerOptions.sources[0].src
            ? _c("video-player", {
                ref: "videoPlayer",
                staticClass: "video-player vjs-custom-skin",
                class: { "video-hidden": !_vm.videoReady },
                attrs: {
                  playsinline: true,
                  options: _vm.playerOptions,
                  events: [
                    "loadstart",
                    "loadedmetadata",
                    "seeking",
                    "seeked",
                    "stalled"
                  ]
                },
                on: {
                  ready: function($event) {
                    return _vm.onPlayerReady($event)
                  },
                  error: function($event) {
                    return _vm.onPlayerError($event)
                  },
                  waiting: function($event) {
                    return _vm.onPlayerWaiting($event)
                  },
                  stalled: function($event) {
                    return _vm.onPlayerWaiting($event)
                  },
                  seeking: function($event) {
                    return _vm.onPlayerSeeking($event)
                  },
                  seeked: function($event) {
                    return _vm.onPlayerSeeked($event)
                  },
                  play: function($event) {
                    return _vm.onPlayerPlay($event)
                  },
                  pause: function($event) {
                    return _vm.onPlayerPause($event)
                  },
                  playing: function($event) {
                    return _vm.onPlayerPlaying($event)
                  },
                  ended: function($event) {
                    return _vm.onPlayerEnded($event)
                  },
                  timeupdate: function($event) {
                    return _vm.onPlayerTimeupdate($event)
                  },
                  loadstart: function($event) {
                    return _vm.onPlayerLoadstart($event)
                  },
                  loadedmetadata: function($event) {
                    return _vm.onPlayerLoadedmetadata($event)
                  },
                  loadeddata: function($event) {
                    return _vm.onPlayerLoadeddata($event)
                  },
                  canplay: function($event) {
                    return _vm.onPlayerCanplay($event)
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.videoReady &&
          !_vm.videoStarted &&
          !_vm.playbackNotice &&
          _vm.playerOptions.sources[0].src
            ? _c(
                "div",
                {
                  staticClass: "custom-play-overlay",
                  on: { click: _vm.playVideo }
                },
                [
                  _c("div", { staticClass: "custom-play-btn" }, [
                    _c(
                      "svg",
                      {
                        staticClass: "custom-play-icon",
                        attrs: {
                          viewBox: "0 0 24 24",
                          fill: "#ffffff",
                          "aria-hidden": "true"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M8 5.5v13a1 1 0 0 0 1.5.87l11-6.5a1 1 0 0 0 0-1.74l-11-6.5A1 1 0 0 0 8 5.5z"
                          }
                        })
                      ]
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.playbackNotice
            ? _c(
                "div",
                {
                  staticClass: "playback-notice",
                  attrs: { role: "status", "aria-live": "polite" }
                },
                [
                  _c("span", [_vm._v(_vm._s(_vm.playbackNotice))]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      attrs: { type: "button" },
                      on: { click: _vm.retryPlayback }
                    },
                    [_vm._v("重新加载视频")]
                  )
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.pdfuri
        ? _c("div", { staticClass: "pdf-container" }, [
            _c("iframe", {
              staticClass: "pdf-iframe",
              attrs: { src: _vm.pdfuri }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "course-info-card" }, [
        _c("div", { staticClass: "course-header" }, [
          !_vm.Curricula_details.Subject
            ? _c("div", { staticClass: "title-skeleton" }, [
                _c("div", { staticClass: "skeleton-line skeleton-title" })
              ])
            : _c("h2", { staticClass: "course-title" }, [
                _vm._v(_vm._s(_vm.Curricula_details.Subject))
              ])
        ]),
        _vm._v(" "),
        !_vm.Curricula_details.Subject
          ? _c("div", { staticClass: "vote-buttons-skeleton" }, [
              _c("div", { staticClass: "skeleton-btn" }),
              _vm._v(" "),
              _c("div", { staticClass: "skeleton-btn" })
            ])
          : _c("div", { staticClass: "vote-buttons" }, [
              _c(
                "span",
                {
                  staticClass: "vote-btn",
                  class: { active: _vm.userVote === 1 },
                  on: {
                    click: function($event) {
                      return _vm.handleVote(1)
                    }
                  }
                },
                [
                  _c("svg", { attrs: { viewBox: "0 0 24 24", fill: "none" } }, [
                    _c("path", {
                      attrs: {
                        d:
                          "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "vote-count" }, [
                    _vm._v(_vm._s(_vm.likes))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "vote-btn",
                  class: { active: _vm.userVote === -1 },
                  on: {
                    click: function($event) {
                      return _vm.handleVote(-1)
                    }
                  }
                },
                [
                  _c("svg", { attrs: { viewBox: "0 0 24 24", fill: "none" } }, [
                    _c("path", {
                      attrs: {
                        d:
                          "M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17",
                        stroke: "currentColor",
                        "stroke-width": "2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "vote-count" }, [
                    _vm._v(_vm._s(_vm.dislikes))
                  ])
                ]
              )
            ]),
        _vm._v(" "),
        _vm.Curricula_details.Reamrk
          ? _c("p", { staticClass: "course-desc" }, [
              _vm._v(_vm._s(_vm.Curricula_details.Reamrk))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showExamCard && _vm.Curricula_details.ExamId
          ? _c(
              "div",
              { staticClass: "exam-entry-card", on: { click: _vm.goToExam } },
              [
                _c("div", { staticClass: "exam-card-icon" }, [_vm._v("📝")]),
                _vm._v(" "),
                _c("div", { staticClass: "exam-card-info" }, [
                  _c("div", { staticClass: "exam-card-title" }, [
                    _vm._v(_vm._s(_vm.Curricula_details.ExamName || "课程考试"))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "exam-card-desc" }, [
                    _vm._v("课程学习已完成，点击进入考试")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "exam-card-arrow" }, [_vm._v("›")])
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "comment-section" }, [
        _c("div", { staticClass: "section-header" }, [
          _c("span", { staticClass: "section-title" }, [_vm._v("全部评论")]),
          _vm._v(" "),
          _vm.Curricula_details.IsOpenEvaluation
            ? _c("span", { staticClass: "comment-count" }, [
                _vm._v(_vm._s(_vm.Evaluation_list.length) + " 条")
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        !_vm.Curricula_details.Subject
          ? _c(
              "div",
              { staticClass: "comment-skeleton" },
              _vm._l(3, function(i) {
                return _c(
                  "div",
                  { key: i, staticClass: "skeleton-comment-item" },
                  [
                    _vm._m(2, true),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "skeleton-line skeleton-content"
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "skeleton-line skeleton-content-short"
                    })
                  ]
                )
              }),
              0
            )
          : _vm.Curricula_details.IsOpenEvaluation
          ? _c(
              "div",
              { staticClass: "comment-list" },
              [
                _vm._l(_vm.Evaluation_list, function(item, index) {
                  return _c(
                    "div",
                    { key: item.Id, staticClass: "comment-item" },
                    [
                      _c("div", { staticClass: "comment-main" }, [
                        _c("div", { staticClass: "comment-meta" }, [
                          _c("span", { staticClass: "comment-floor" }, [
                            _vm._v("#" + _vm._s(index + 1))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "comment-author" }, [
                            _vm._v(_vm._s(_vm.maskName(item.Name)))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "comment-body" }, [
                          _vm._v(_vm._s(item.Content))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "comment-footer" }, [
                          _c(
                            "span",
                            {
                              staticClass: "reply-btn",
                              on: {
                                click: function($event) {
                                  return _vm.openCommentPanel(item)
                                }
                              }
                            },
                            [_vm._v("回复")]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      item.evaluationVWs && item.evaluationVWs.length > 0
                        ? _c(
                            "div",
                            { staticClass: "reply-list" },
                            _vm._l(item.evaluationVWs, function(reply) {
                              return _c(
                                "div",
                                { key: reply.Id, staticClass: "reply-item" },
                                [
                                  _c("span", { staticClass: "reply-author" }, [
                                    _vm._v(_vm._s(_vm.maskName(reply.Name)))
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "reply-content" }, [
                                    _vm._v(_vm._s(reply.Content))
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "reply-action",
                                      on: {
                                        click: function($event) {
                                          return _vm.openCommentPanel(reply)
                                        }
                                      }
                                    },
                                    [_vm._v("回复")]
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.Evaluation_list.length === 0
                  ? _c("div", { staticClass: "empty-comment" }, [
                      _c("p", [_vm._v("暂无评论，点击右下角发表第一条评论")])
                    ])
                  : _vm._e()
              ],
              2
            )
          : _c("div", { staticClass: "comment-closed" }, [
              _c("p", [_vm._v("该课程暂未开启评论")])
            ])
      ]),
      _vm._v(" "),
      _vm.Curricula_details.IsOpenEvaluation
        ? _c(
            "div",
            {
              staticClass: "comment-fab",
              on: {
                click: function($event) {
                  return _vm.openCommentPanel(null)
                }
              }
            },
            [
              _c("svg", { attrs: { viewBox: "0 0 24 24", fill: "none" } }, [
                _c("path", {
                  attrs: {
                    d:
                      "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10z",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }
                })
              ]),
              _vm._v(" "),
              _vm.Evaluation_list.length > 0
                ? _c("span", { staticClass: "fab-badge" }, [
                    _vm._v(_vm._s(_vm.Evaluation_list.length))
                  ])
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.showCommentPanel
          ? _c("div", {
              staticClass: "comment-overlay",
              on: { click: _vm.closeCommentPanel }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-up" } }, [
        _vm.showCommentPanel
          ? _c("div", { staticClass: "comment-panel" }, [
              _c("div", { staticClass: "panel-header" }, [
                _c("span", { staticClass: "panel-title" }, [
                  _vm._v(
                    _vm._s(_vm.HF_IF ? "回复 " + _vm.replyTarget : "发表评论")
                  )
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "panel-close",
                    on: { click: _vm.closeCommentPanel }
                  },
                  [_vm._v("×")]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "panel-body" },
                [
                  _c("van-field", {
                    ref: "bot_field",
                    staticClass: "panel-textarea",
                    attrs: {
                      rows: "4",
                      autosize: "",
                      type: "textarea",
                      placeholder: _vm.placeholder_text
                    },
                    model: {
                      value: _vm.input_pl,
                      callback: function($$v) {
                        _vm.input_pl = $$v
                      },
                      expression: "input_pl"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "panel-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "panel-cancel",
                    on: { click: _vm.closeCommentPanel }
                  },
                  [_vm._v("取消")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "panel-submit",
                    attrs: { disabled: _vm.commentSubmitting },
                    on: { click: _vm.submit_pl }
                  },
                  [_vm._v("发表")]
                )
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("unlock-tip-dialog", {
        attrs: {
          show: _vm.show_unlock_tip,
          "unlock-data": _vm.unlockTipData,
          "show-back-button": true
        },
        on: {
          "update:show": function($event) {
            _vm.show_unlock_tip = $event
          },
          "go-course": _vm.goToPreCourse,
          back: _vm.goBack
        }
      }),
      _vm._v(" "),
      _c(
        "van-dialog",
        {
          attrs: {
            title: "恭喜完成课程学习!",
            "show-cancel-button": true,
            "confirm-button-text": "去考试",
            "cancel-button-text": "稍后",
            "confirm-button-color": "#d51900"
          },
          on: { confirm: _vm.goToExam },
          model: {
            value: _vm.showExamEntry,
            callback: function($$v) {
              _vm.showExamEntry = $$v
            },
            expression: "showExamEntry"
          }
        },
        [
          _c("div", { staticClass: "exam-entry-content" }, [
            _c("p", { staticClass: "exam-entry-text" }, [
              _vm._v(_vm._s(_vm.Curricula_details.ExamName || "点击进入考试"))
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h1", { staticClass: "page-title" }, [_vm._v("📖 课程学习")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "skeleton-play-btn" }, [
      _c("div", { staticClass: "skeleton-spinner" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "skeleton-comment-meta" }, [
      _c("div", { staticClass: "skeleton-line skeleton-floor" }),
      _vm._v(" "),
      _c("div", { staticClass: "skeleton-line skeleton-author" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-032f044b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-032f044b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/classStudy.vue
// module id = null
// module chunks = 